import { TFunction } from 'i18next';

export const tablePaginationLocalization = (t: TFunction) => ({
  labelRowsSelect: t('pagination.rows'),
  labelDisplayedRows: `{from}–{to} ${t('pagination.of')} {count}`,
});

export const displayedRowsLabel = (
  t: TFunction,
  { from, to, count }: { from: number; to: number; count: number },
) => `${from}–${to} ${t('pagination.of')} ${count}`;
